import React, { Component, createRef, Suspense } from 'react'

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

/* Constants */
import { images, env, sound, utils } from './constants'
import { LOADING, ERROR, CHOICE, GAME, WAITING, DEALING, statusList } from './constants/status'
import { BOXES, createEmptyStake } from './constants/values'

/* UUID */
import { v4 as uuidv4 } from 'uuid'

/* Poker UI */
import { Error, Background, GameControl, Balance, Internet, GameInfo, Status, Notification, FloatingMessages, InactionTiming } from '@cuba-go/poker-ui'

/* Widgets */
import { Preloader } from './widgets'

/* Rules */
import { list as rules } from './constants/rules'
import { messages } from "./api/Support"

/* REST API */
import { history } from './api/History'

import { UltimateRates, GamePayout, UvpTimer } from './components'

import { Bet, PlayerCards, DealerCards, AdditionalCards, Buttons, Boxes, UVPHistory } from './widgets'

/* Intenet speed check url */
const imgUrl = "https://inbusiness.kz/uploads/2025-1/dFpAGSXY.webp"

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

let hidden = null
let visibilityChange = null
if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
}
else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
}
else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
}

/* Entry Point */
class App extends Component {


    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {
            /* General */
            cached: false,
            status: LOADING,

            playerId: data.playerId,
            boxPlayers: [null, null, null],

            showTimer: false,
            innerTimeShow: true,
            currentTime: 0,

            stakes: [
                createEmptyStake(),
                createEmptyStake(),
                createEmptyStake()
            ],
            last: [
                createEmptyStake(),
                createEmptyStake(),
                createEmptyStake()
            ],
            list: [],
            balance: null,
            total: 0,

            playerCards: [[], [], []],
            dealerCards: [],
            additionalCards: [],

            boxGames: [null, null, null],
            dealerGame: null,

            gameBox: null,

            showButton: false,
            solution: null,
            freezedButton: false,

            result: [null, null, null],
            winTotal: 0,
            winType: "",

            currency: (token && data && data.currency) ? data.currency : 'USD',
            identifier: (token && data && data.identifier) ? data.identifier : '1',

            lastWin: 0,
            activeChip: 3,

            /* Dealer */
            dealerInfo: null,

            /* Game Info */
            max: data && data.max ? data.max : 5000,
            min: data && data.min ? data.min : 50,
            maxPay: data && data.maxPay ? data.maxPay : 100000,

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,
            isPaused: false,
            isClosed: false,

            /* Other */
            chips: data && data.chips && Array.isArray(data.chips) ? data.chips : [],
            backColor: data && data.backColor ? data.backColor : "",
            gameImg: data && data.gameImg ? `${env.mediapoint}/images/table-images/` + data.gameImg : null,

        }

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, type: "player" } })

        /* Timing ref */
        this._balanceErrorTiming = null
        this._maxBetErrorTiming = null

        /* Backfround ref */
        this._background = createRef(null)

    }

    componentDidMount = () => {
        this.game()
        this.cache()
        this.loadHistory(1)
        this.loadSupportMessages()

        document.addEventListener(visibilityChange, this.handleVisibilityChange)
    }

    componentWillUnmount() {
        document.removeEventListener(visibilityChange, this.handleVisibilityChange)
    }


    handleVisibilityChange = () => {
        if (document[hidden]) {
            this.setState({ innerTimeShow: false })
        } else {
            if (this.state.currentTime > 1) {
                this.setState({ showTimer: true })
            }
            setTimeout(() => {
                this.setState({ innerTimeShow: true })
            }, 250)
        }
    }

    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        if (page > 1) {
            this.setState({ historyPage: page })
        }

        history(token, page).then(response => {
            if (response.status === 200) {
                let list = response.data
                if (page > 1) {
                    list = [...histories, ...response.data]
                }

                if (response.data.length < 5) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }

    /* Load Support Messages */
    loadSupportMessages = () => {
        messages(token).then(response => {
            if (response.status === 200) {

                /* Create Timer */
                const timer = setTimeout(() => {

                    /* Set Support Messages */
                    if (this._background && this._background.current) {
                        this._background.current.setSupportMessage(response.data)
                    }

                    /* Clear Timer */
                    clearTimeout(timer)

                }, 2100)

            }
        })
    }

    /* Send Message */
    sendMessage = message => {
        this.socket.emit("messageFromPlayer", message.message)
        if (this._floatingMessages) {
            this._floatingMessages.sendMessage(message)
        }
    }

    /* Send Message */
    sendSupportMessage = message => {
        this.socket.emit("supportMessage", message.message)
    }

    game = () => {
        /* On error */
        this.socket.on("connect_error", () => {

            this.clear()

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)

            this.clearTiming()
        })

        /*  */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
            this.clear()
            this.clearTiming()
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                clearTimeout(timer)
                this.resetTimer()
            }, 2000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
            this.clear()
            this.clearTiming()
        })

        /* On Inaction */
        this.socket.on("setInactionState", () => {
            this.setState({ isDisconnected: true })
            this.socket.disconnect()
            this.clear()
            this.clearTiming()
        })

        /* On close Table */
        this.socket.on("closeTable", value => {

            if (value) {
                /* Close Notification */
                this.notify("tableClosed", "close")
                this.loadHistory(1)
                this.clear()
            }

            this.setState({ isClosed: value, status: WAITING })
        })

        /* On tableCloseNext */
        this.socket.on("tableCloseNext", () => {

            /* Show Notification */
            this.notify("tableClosed", "show")

        })

        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })

        /* Get pause command from dealer monitor */
        this.socket.on("pause", () => {
            this.setState({ isPaused: true })
            this.notify('pause', 'show')
            this.clearTiming()
        })

        /* Continue Event */
        this.socket.on("continue", () => {
            this.setState({ isPaused: false })
            this.notify('pause', 'close')
        })


        /* Player join box */
        this.socket.on("boxJoin", data => {
            const { playerData, box } = data
            const { boxPlayers, total, playerId } = this.state
            let tempBoxPlayers = [...boxPlayers]
            tempBoxPlayers[box] = playerData
            this.setState({ boxPlayers: tempBoxPlayers })
        })

        this.socket.on("boxLeft", box => {

            const { boxPlayers, stakes, playerId, total } = this.state
            const boxTotal = stakes[box].ante * 2 + stakes[box].trips
            if (boxPlayers[box] && boxPlayers[box].playerId === playerId && stakes[box]) {
                this.setState({ total: total - boxTotal })
            }

            const newBoxPlayers = [...boxPlayers]
            newBoxPlayers[box] = null

            const newStakes = [...stakes]
            newStakes[box] = createEmptyStake()

            this.setState({ boxPlayers: newBoxPlayers, stakes: newStakes })

        })

        this.socket.on("boxPlayers", data => {
            this.setState({ boxPlayers: data })
        })

        this.socket.on("playerBoxStake", data => {
            const { stake, index } = data
            const { stakes } = this.state
            let tempStakes = [...stakes]
            tempStakes[index] = stake

            this.setState({ stakes: tempStakes })
        })

        this.socket.on("stakesSync", (stakes) => {
            const { boxPlayers, playerId } = this.state
            this.setState({ stakes })
            let total = 0
            if (stakes && Array.isArray(stakes)) {
                stakes.forEach((stake, i) => {
                    if (stake && stake.ante && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId) {
                        total += stake.ante * 2 + stake.trips
                    }
                })
            }
            this.setState({ total })
        })

        this.socket.on("stakeRejected", (stakes) => {
            const { boxPlayers, playerId } = this.state
            let total = 0
            if (stakes && Array.isArray(stakes)) {
                stakes.forEach((stake, i) => {
                    if (stake && stake.ante && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId) {
                        total += stake.ante * 2 + stake.trips
                    }
                })
            }
            this.setState({ stakes, total, showTimer: false })
            this.updateTimer()
        })

        this.socket.on("playersStake", data => {
            this.setState({ stakes: data })
        })

        this.socket.on("lastStake", data => {
            this.setState({ last: data })
        })

        /* On start */
        this.socket.on("status", data => {
            const { status, timer, clear, forceEnd } = data

            if (status !== this.state.status) {
                this.setState({ status })
            }

            if (timer) {
                this.updateTimer()
                this.setState({ showTimer: true, currentTime: timer, showButton: statusList.includes(status), freezedButton: false })
                this.checkTimer(timer)
            }

            if (status === GAME) {
                this.setState({ solution: null })
            }

            if (status === CHOICE && this.state.status !== CHOICE) {
                this.loadHistory(1)
                this.setState({ isClosed: false })
                this.notify("tableClosed", "close")
            }

            if (clear) {
                this.clear()
            }

            if (forceEnd) {
                this.notify("pause", "close")

                const timer = setTimeout(() => {
                    this.notify("forceEnd", "show")

                    const close = setTimeout(() => {
                        this.notify("forceEnd", "close")
                        clearTimeout(close)
                    }, 4000)

                    clearTimeout(timer)
                }, 2000)
            }

        })

        this.socket.on("clearData", () => {
            const { boxPlayers, playerId } = this.state
            if (boxPlayers) {
                const i = boxPlayers.findIndex(e => e && e.playerId === playerId)
                if (i === -1) {
                    this.clear()
                }
            }
        })

        /* Hide Timer */
        this.socket.on("hideTimer", () => {
            this.setState({ showTimer: false, currentTime: 0 })
            this.updateTimer()
        })

        /* Reconnection */
        this.socket.on("reconnection", data => {
            if (data) {

                this.reconnectionClear()

                let time = 1500

                if (data.reason && data.reason === "transaction") {
                    this.notify("transaction", 'show')
                    time = 3000
                }

                let action = null

                const status = data.status

                const isPaused = data.isPaused

                setTimeout(() => {

                    this.setState({
                        status,
                        isClosed: data.isClosed,
                        boxPlayers: data.boxPlayers,
                        stakes: data.stakes
                            ? data.stakes.map(s => ({ ...s }))
                            : [
                                createEmptyStake(),
                                createEmptyStake(),
                                createEmptyStake()
                            ],
                        boxCards: data.boxCards,
                        dealerCards: data.dealerCards,
                        additionalCards: data.additionalCards,
                        boxGames: data.boxGames,
                        dealerGame: data.dealerGame,
                        gameInfo: data.gameInfo,
                        last: data.last ? data.last : null,
                        total: data.total ? data.total : 0,
                        gameBox: data.gameBox,
                        transactions: data.transactions ? data.transactions : [],

                        dealerInfo: data.dealerData,
                        showButton: statusList.includes(status)
                    })

                    this.updateResult(data.result, data.winTotal, data.boxPlayers)

                    setTimeout(() => {
                        this.setState({
                            status: data.status,
                            showTimer: data.timer ? true : false,
                            currentTime: data.timer ? parseInt(data.timer) - 1 : 0,
                        })
                        if (data.timer) {
                            this.checkTimer(data.timer)
                        }
                    }, 200)


                    if (isPaused) {
                        this.notify("pause", "show")
                    }

                    this.notify("pause", 'close')
                    this.notify("transaction", 'close')

                    // if (ante) {

                    // }

                }, 1000)

            }
        })

        /* Clear Game */
        this.socket.on("clearGame", () => {
            this.clear()
            this.loadHistory()
        })

        /* Game box */
        this.socket.on("gameBox", data => {
            this.setState({ gameBox: data.box })
        })

        /* Get a dealer Info */
        this.socket.on("dealerData", data => {
            const { status } = this.state
            this.setState({ dealerInfo: data })

            if (status === null) {
                this.setState({ status: CHOICE })
            }
        })

        /* Get a dealer card */
        this.socket.on("dealer", data => {
            const { dealerCards } = this.state
            const i = dealerCards.findIndex(e => e.id === data.id)
            if (i === -1) {
                let cards = dealerCards
                cards.unshift(data)
                this.setState({ dealerCards: cards })
            }
        })

        this.socket.on("dealerCards", data => {
            this.setState({ dealerCards: data })
        })

        this.socket.on("dealerGame", data => {
            this.setState({ dealerGame: data })
        })

        /* Get a additional card */
        this.socket.on("additional", data => {
            const { additionalCards } = this.state
            const i = additionalCards.findIndex(e => e.id === data.id)
            if (i === -1) {
                let cards = additionalCards
                cards.unshift(data)
                this.setState({ additionalCards: cards })
            }
        })

        /* Get a Player card */
        this.socket.on("player", data => {

        })

        this.socket.on("boxCards", data => {
            this.setState({ boxCards: data })
        })

        this.socket.on("boxGames", data => {
            this.setState({ boxGames: data })
        })

        this.socket.on("dealerCards", data => {
            this.setState({ dealerCards: data })
        })

        this.socket.on("additionalCards", data => {
            this.setState({ additionalCards: data })
        })

        /* Get a game status after inaction  */
        this.socket.on("action", data => {

            const { solution } = this.state
            const { autopass, check, box } = data

            if (autopass) {
                this.notify("autopass", "show")
                setTimeout(() => {
                    this.notify("autopass", "close")
                }, 5000);

                if (box || box === 0) {
                    let players = [...this.state.boxPlayers]
                    players[box].pass = true
                    if (!solution) {
                        this.setAction('pass')
                    }
                    this.setState({ boxPlayers: players })
                }
            } else if (check) {
                if (!solution) {
                    this.setAction('check')
                }

            }

        })

        this.socket.on("boxPlayerAction", data => {
            const { action, box } = data
            let tempBoxPlayers = [...this.state.boxPlayers]
            if (tempBoxPlayers && tempBoxPlayers[box]) {
                if (action === 'pass') {
                    tempBoxPlayers[box].pass = true
                } else {
                    tempBoxPlayers[box].betX = action
                }
                this.setState({ boxPlayers: tempBoxPlayers })
            }
        })

        /* Result */
        this.socket.on("resultData", data => {

            const { result, win } = data

            this.updateResult(result, win)
        })

        /* Message */
        this.socket.on("message", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addMessage(data)
            }
        })

        /* On Support Message */
        this.socket.on("adminSupportAnswer", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addSupportMessage(data)
            }
        })

        /* Notification */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get Game Info */
        this.socket.on("refund", data => {
            this.notify("refund", "refund", { type: "refund", total: data })
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { transactions, operations } = this.state
                let list = [data, ...transactions]
                let operationsList = [data, ...operations]
                this.setState({ transactions: list, operations: operationsList })

                setTimeout(() => {
                    let operationsList = this.state.operations
                    operationsList = operationsList.filter(item => item.id !== data.id)
                    this.setState({ operations: operationsList })
                }, 3500)

            }
        })

        this.socket.on("editTransaction", data => {
            const { transactions } = this.state
            let list = transactions
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ transactions: list })
            }
        })

    }

    /* Clear timing to remove sound */
    clearTiming = () => {
        if (this._timing) {
            this._timing.clear()
        }
        setTimeout(() => {
            if (this._timing) {
                this._timing.clear()
            }
        }, 1500)
    }

    reconnectionClear = () => {

    }

    /* Show and close notifications */
    notify = (type, action, data = null) => {

        const notifyData = { type, action, data }

        if (this._notify) {
            this.notifyAction(notifyData)
        }
        else {
            setTimeout(() => {
                if (this._notify) {
                    this.notifyAction(notifyData)
                }
            }, 2000)
        }

    }

    /* Do notify actions after notify component check */
    notifyAction = (notifyData) => {

        const { type, action, data = null } = notifyData
        if (action === "show") {
            this._notify.show(type)
        }
        else if (action === 'close') {
            this._notify.close(type)
        }
        else if (action === 'refund') {
            if (data.total) {

                const title = data.type === 'refund' ? 'Возврат средств' : "Пополнение суммы"
                const uid = uuidv4()
                this._notify.refund({ title, total: data.total, uid })
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {
        if (parseInt(speed) < 5) {
            this.notify('internet', 'show')
        }
        else {
            this.notify('internet', 'close')
        }
    }


    /* Reser top timing */
    updateTimer = () => {
        clearInterval(this.timerInterval)
        this.timerInterval = null
        this.setState({ currentTime: 0 })
    }

    checkTimer = (timer) => {

        if (timer && timer > 1) {
            let tempCurrentTime = timer

            this.timerInterval = setInterval(() => {
                tempCurrentTime -= 1
                this.setState({ currentTime: tempCurrentTime })
                if (tempCurrentTime && tempCurrentTime > 0 && tempCurrentTime < 5) {
                    sound.play('tic', 0.5)
                }
                if (tempCurrentTime === 0 || tempCurrentTime < 0) {
                    this.setState({ showTimer: false })
                    this.updateTimer()

                    if (!this.state.solution && this.state.status !== CHOICE) {
                        this.setState({ freezedButton: true })
                    } else {
                        this.setState({ status: DEALING })
                    }
                }
            }, 1000)
        }

    }

    /* Cache images */
    cache = async () => {

        const promises = images.data.map(uri => {

            return new Promise(function (resolve, reject) {
                const img = new Image()
                img.src = uri
                img.onload = resolve()
                img.onerror = reject()
            })

        })

        await Promise.all(promises)

        this.setState({ cached: true })
    }

    /* Reser top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }


    /* Toggle Balance Error */
    toggleBalanceError = () => {

        if (!this._balanceErrorTiming) {
            this.notify('balanceError', 'show')
        }

        if (this._balanceErrorTiming) {
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }

        this._balanceErrorTiming = setTimeout(() => {
            this.notify('balanceError', 'close')
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }, 2000)

        sound.play("blocked")

    }

    /* Toggle Balance Error */
    toggleMaxBetError = () => {

        if (!this._maxBetErrorTiming) {
            this.notify('maxBetError', 'show')
        }

        if (this._maxBetErrorTiming) {
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }

        this._maxBetErrorTiming = setTimeout(() => {
            this.notify('maxBetError', 'close')
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }, 2000)

        sound.play("blocked")

    }

    updateResult = (result, sum, list) => {

        const { playerId } = this.state

        this.setState({ result })

        let maxPayCheck = false
        let win = "lose"
        let cnt = 0

        const boxPlayers = list && Array.isArray(list) ? list : this.state.boxPlayers

        boxPlayers && Array.isArray(boxPlayers) && boxPlayers.forEach((p, index) => {
            if (p && p.playerId === playerId && result && result[index]) {

                cnt += 1

                if (result[index].result === 'draw' && win !== 'win') {
                    win = 'draw'
                }

                if (result[index].result === 'win' || result[index].playerTrips) {
                    win = "win"
                }

                if (result[index].maxPayCheck) {
                    maxPayCheck = true
                }
            }
        })

        if (cnt) {
            this.setState({ winTotal: sum, winType: win, lastWin: sum })
        }

        if (maxPayCheck) {

            /* Close Notification */
            this.notify("maxPay", "show")

            setTimeout(() => {
                this.notify("maxPay", "close")
            }, 3500);

        }

    }

    boxJoin = box => {
        if (!this.state.isClosed) {
            this.socket.emit("join", box)
        } else {
            sound.play("blocked")
        }
    }

    boxLeft = box => {
        this.socket.emit("left", box)
    }

    /* Set ante value */
    setStakes = (data) => {

        const { playerId, boxPlayers, isClosed } = this.state

        if (!isClosed) {
            const changed = []

            data.forEach((stake, index) => {
                if (
                    boxPlayers[index] &&
                    boxPlayers[index].playerId === playerId
                ) {
                    changed.push({ index, stake })
                }
            })

            this.socket.emit("stakesPartial", changed)

            sound.play("sound")
            this.resetTimer()
        } else {
            sound.play("blocked")
        }

    }

    /* Set action from player to server */
    setAction = (solution) => {
        const { balance, betX, status, gameBox, boxPlayers, total } = this.state

        let tempBoxPlayers = [...boxPlayers]

        this.resetTimer()

        if (!betX && statusList.includes(status)) {

            const ante = this.state.stakes[gameBox]?.ante || 0

            let success = false

            if (solution === 'pass' || solution === 'check') {
                this.setState({ solution })
                success = true
                this.socket.emit("playerAction", { action: solution, box: gameBox })

                if (solution === "pass") {
                    tempBoxPlayers[gameBox].pass = true
                    this.setState({ boxPlayers: tempBoxPlayers })
                    sound.play('autopass')
                }
            } else if (ante) {
                const betX = parseInt(solution)
                const betTotal = parseInt(ante) * (betX)
                if (betTotal > balance) {
                    this.toggleBalanceError()
                } else {
                    tempBoxPlayers[gameBox].betX = betX
                    this.setState({ solution: solution, boxPlayers: tempBoxPlayers, total: total + betTotal })
                    success = true
                    this.socket.emit("playerAction", { action: 'bet', betX, box: gameBox })
                    sound.play("sound")
                }
            } else {
                this.toggleBalanceError()
                return
            }

            if (success) {
                this.setState({ showTimer: false, currentTime: 0, gameBox: null, freezedButton: false })

                setTimeout(() => {
                    this.setState({ showButton: false, solution: null, status: DEALING })
                }, 1500);
                this.updateTimer()
            }
        }

    }


    /* Clear all variables */
    clear = () => {

        const { boxPlayers } = this.state

        let tempBoxPlayers = [...boxPlayers]
        tempBoxPlayers.forEach(player => {
            if (player) {
                if (player.betX) {
                    player.betX = null
                }
                if (player.pass) {
                    player.pass = false
                }
            }
        })

        this.setState({
            boxPlayers: tempBoxPlayers,
            showTimer: false,
            currentTime: 0,

            stakes: [
                createEmptyStake(),
                createEmptyStake(),
                createEmptyStake()
            ],

            list: [],
            total: 0,

            boxCards: [[], [], []],
            dealerCards: [],
            additionalCards: [],

            boxGames: [null, null, null],
            dealerGame: null,

            gameBox: null,

            solution: null,
            freezedButton: false,

            result: [null, null, null],
            winTotal: 0,
            winType: "",

            gameInfo: null,
            transactions: [],
            lastWin: 0
        })
    }

    /* Dealer Cards */
    _dealer_cards = (text = '') => {

        const { dealerCards, dealerGame } = this.state

        let style = ''

        if (text === 'nextgame' && dealerCards.length === 0) {
            style = ''
        }

        return (
            <DealerCards
                cards={dealerCards}
                game={dealerGame}
                style={style}
            />
        )

    }

    // Additional cards
    _additional_cards = (text = '') => {

        const { additionalCards } = this.state

        let style = ''

        if (text === 'nextgame' && additionalCards.length === 0) {
            style = ''
        }

        return (
            <AdditionalCards
                cards={additionalCards}
                style={style}
            />
        )

    }

    /* Player Cards */
    _player_cards = (box) => {

        const { status, boxPlayers, playerId, stakes, boxCards, boxGames, action, gameBox } = this.state

        const player = boxPlayers && boxPlayers[box] ? boxPlayers[box] : null
        const cards = boxCards && boxCards[box] && Array.isArray(boxCards[box]) ? boxCards[box] : []
        const game = boxGames && boxGames[box] ? boxGames[box] : null
        const length = utils.arrayLength(boxPlayers)
        const isPlayerGameBox = (gameBox || gameBox === 0) ? boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId : false

        if (player && stakes && stakes[box].ante || length === 0 || status === CHOICE) {
            return (
                <PlayerCards
                    cards={cards}
                    game={game}
                    action={action}
                    box={box}
                    gameBox={gameBox}
                    isPlayerGameBox={isPlayerGameBox}
                    pass={player ? player.pass : false}
                    length={length}
                    key={`box-c-${box}`}
                />
            )
        }

        return null

    }

    /* Draw Result */
    _result = () => {

        const { winTotal, winType, currency } = this.state

        if (winType && winType.length > 0) {
            return <Status status="result" data={{ sum: winTotal, result: winType, reason: 'bet' }} currency={currency} />
        }
    }

    /* Buttons */

    _buttons = (landscape = false) => {

        const { status, showButton, result, solution, freezedButton } = this.state

        const visible = showButton && status !== DEALING && !utils.arrayLength(result)

        if (visible) {
            return (
                <Buttons
                    status={status}
                    solution={solution}
                    freezedButton={freezedButton}
                    setAction={data => this.setAction(data)}
                    landscape={landscape}
                />
            )
        }

        return null

    }

    box = () => {

        const { boxPlayers, stakes, status, playerId, total, last, currentTime, activeChip, balance, list, currency, max, min, chips, backColor, isClosed } = this.state

        const gameplay = status === DEALING || status === GAME || statusList.includes(status)

        const boxStyle = ''

        const i = boxPlayers.findIndex(e => e && e.playerId === playerId)

        if (gameplay) {
            return (
                <div className='play'>

                    {this._result()}

                    <div className="card-box">

                        {this._dealer_cards()}

                        {this._additional_cards()}

                        <div className="card-box-bottom">
                            <div className="ump-player-game">
                                <div className='box-cards'>
                                    {BOXES.map(item => this._player_cards(item))}
                                </div>
                            </div>
                        </div>

                        {this._buttons()}

                    </div>

                    {this._buttons(true)}

                </div>
            )
        }

        if (status === CHOICE && i !== -1) {
            return (
                <Suspense>
                    <Bet
                        stakes={stakes}
                        boxPlayers={boxPlayers}
                        playerId={playerId}
                        last={last}
                        total={total}
                        active={activeChip}
                        setActiveChip={data => this.setState({ activeChip: data })}
                        setStakes={data => this.setStakes(data)}
                        balance={balance}
                        currency={currency}
                        toggleBalanceError={() => this.toggleBalanceError()}
                        toggleMaxBetError={() => this.toggleMaxBetError()}
                        boxStyle={boxStyle}
                        isChoice={status === CHOICE}
                        max={max}
                        min={min}
                        chips={chips}
                        backColor={backColor}
                        list={list}
                        setList={data => this.setState({ list: data })}
                        currentTime={currentTime}
                        isClosed={isClosed}
                    />
                </Suspense>
            )
        }

        return (
            <div className='play'>

                {/* <div className="card-box">

                    {this._dealer_cards('nextgame')}

                    {this._additional_cards('nextgame')}

                    <div className="card-box-bottom">
                        <div className='box-cards'>
                            {BOXES.map(item => this._player_cards(item))}
                        </div>
                    </div>

                </div> */}

            </div>
        )
    }



    render = () => {

        const { status, gameBox, playerId, boxPlayers, stakes, result, solution, winType, showTimer, currentTime, innerTimeShow, activeChip, cached, dealerInfo, currency, total, balance, lastWin, action, ante, transactions, gameInfo, list, operations, histories, historyPage, historyHasMore, closed, newDevice, max, min, maxPay, isDisconnected, isPaused, identifier, backColor, gameImg, chips, isClosed } = this.state

        const nextGame = status === WAITING

        const style = (nextGame || newDevice || closed || isDisconnected) ? "hidden" : action ? "blured" : ""

        let i = -1

        if (boxPlayers && Array.isArray(boxPlayers) && boxPlayers.length > 0) {
            i = boxPlayers.findIndex(e => e && e.playerId === playerId)
        }

        const activeBoxesLength = boxPlayers && Array.isArray(boxPlayers) ? boxPlayers.filter(e => e && e.playerId).length : 0

        const ind = result && Array.isArray(result) ? result.findIndex((e, i) => e && e.result === "win" && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId) : -1

        const resultVisible = ind !== -1

        const gamePayout = <GamePayout currency={currency} max={max} min={min} />

        const notificationStatus =
            isClosed ? "tableClosedFinal" :
                !dealerInfo
                    ? "dealer"
                    : i === -1
                        ? (activeBoxesLength === 3 ? "busy" : "choose-the-box")
                        : status !== CHOICE && !total ? "waiting" : ""

        let content = (
            <Background token={token} gameType="ultimate" ref={this._background} historyComponent={UVPHistory} gamePlace={env.gamePlace} currency={currency} maxPay={maxPay} status={status} dealer={dealerInfo} sendMessage={message => this.sendMessage(message)} sendSupportMessage={message => this.sendSupportMessage(message)} info={gameInfo} transactions={transactions} histories={histories} loadMore={() => this.loadHistory(historyPage + 1)} historyHasMore={historyHasMore} identifier={identifier} rules={rules} gamePayout={gamePayout} videoBackImg={gameImg} textileColor={backColor}>

                {showTimer && !resultVisible ? <UvpTimer status={status} currentTime={currentTime} innerTimeShow={innerTimeShow} hide={() => this.setState({ showTimer: false })} /> : null}
                <InactionTiming time={240} ref={ref => this._inaction = ref} status={status} isPaused={isPaused} setInactionState={() => this.setInactionState()} />

                <GameInfo currency={currency} info={gameInfo} operations={operations} />
                <GameControl title={`3 Hand Ultimate Texas Holdem`} maxPay={maxPay} max={max} min={min} currency={currency} info={gameInfo} data={dealerInfo} gamePayout={gamePayout} onQuitGame={() => this.quitGame()} />
                {/* title={`Ultimate Texas Holdem ${status} ${showTimer ? "show true" : " show false"} ${!resultVisible ? 'res true' : "res false"} */}
                <Balance balance={balance} total={total} lastWin={lastWin} currency={currency} />
                <FloatingMessages ref={ref => this._floatingMessages = ref} />

                <Suspense>
                    {this.box()}
                </Suspense>

                <Suspense>
                    <Boxes
                        dealerInfo={dealerInfo}
                        isChoice={status === CHOICE}
                        boxPlayers={boxPlayers}
                        stakes={stakes}
                        boxJoin={box => this.boxJoin(box)}
                        boxLeft={box => this.boxLeft(box)}
                        backColor={backColor}
                        playerId={playerId}
                        gameBox={gameBox}
                        active={activeChip}
                        chips={chips}
                        setStakes={data => this.setStakes(data)}
                        balance={balance}
                        max={max}
                        toggleBalanceError={() => this.toggleBalanceError()}
                        toggleMaxBetError={() => this.toggleMaxBetError()}
                        list={list}
                        setList={list => this.setState({ list })}
                        result={result}
                    />
                </Suspense>

                <Notification notificationStatus={notificationStatus} ref={ref => this._notify = ref} currency={currency} max={max} maxPay={maxPay} />

                <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />

            </Background>
        )

        if (status === ERROR || newDevice || closed || isDisconnected) {
            content = <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} />
        }

        if (status === LOADING || !cached) {
            content = <Preloader url={gameImg} />
        }

        return content
    }

}

export default App